import "core-js/modules/es.array.concat";
import "core-js/modules/es.function.name";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: {
    info: null,
    detail: {
      all: {
        list: [],
        loaded: false,
        requesting: false
      },
      coin: {
        list: [],
        loaded: false,
        requesting: false
      },
      user: {
        list: [],
        loaded: false,
        requesting: false
      },
      you_zan: {
        list: [],
        loaded: false,
        requesting: false
      }
    },
    integral: {
      all: {
        list: [],
        loaded: false,
        requesting: false
      },
      income: {
        list: [],
        loaded: false,
        requesting: false
      },
      expend: {
        list: [],
        loaded: false,
        requesting: false
      }
    }
  },
  mutations: {
    setInfo: function setInfo(state, info) {
      state.info = info;
    },
    initDetail: function initDetail(state, _a) {
      var type = _a.type;
      state.detail[type].list = [];
      state.detail[type].loaded = false;
      state.detail[type].requesting = false;
    },
    concatDetail: function concatDetail(state, _a) {
      var type = _a.type,
          list = _a.list;
      state.detail[type].list = state.detail[type].list.concat(list);
    },
    setDetailLoaded: function setDetailLoaded(state, _a) {
      var type = _a.type,
          loaded = _a.loaded;
      state.detail[type].loaded = loaded;
    },
    setDetailReq: function setDetailReq(state, _a) {
      var type = _a.type,
          req = _a.req;
      state.detail[type].requesting = req;
    },
    initIntegral: function initIntegral(state, _a) {
      var type = _a.type;
      state.integral[type].list = [];
      state.integral[type].loaded = false;
      state.integral[type].requesting = false;
    },
    concatIntegral: function concatIntegral(state, _a) {
      var type = _a.type,
          list = _a.list;
      state.integral[type].list = state.integral[type].list.concat(list);
    },
    setIntegralLoaded: function setIntegralLoaded(state, _a) {
      var type = _a.type,
          loaded = _a.loaded;
      state.integral[type].loaded = loaded;
    },
    setIntegralReq: function setIntegralReq(state, _a) {
      var type = _a.type,
          req = _a.req;
      state.integral[type].requesting = req;
    }
  },
  actions: {
    getInfo: function getInfo(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/coin/info')];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setInfo', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getDetail: function getDetail(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var type = _b.type,
          offset = _b.offset,
          count = _b.count,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.detail[type];

              if (offset === 0 && forceUpdate) {
                commit('initDetail', {
                  type: type
                });
                wrap = state.detail[type];
              }

              if (wrap.loaded || wrap.requesting) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setDetailReq', {
                type: type,
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/coin/detail', {
                params: {
                  type: type === 'all' ? undefined : type,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatDetail', {
                  type: type,
                  list: list
                });

                if (list.length < count) {
                  commit('setDetailLoaded', {
                    type: type,
                    loaded: true
                  });
                }
              }

              commit('setDetailReq', {
                type: type,
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 提现
     */
    withdraw: function withdraw(_a, _b) {
      var dispatch = _a.dispatch;
      var count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/coin/withdraw', {
                count: count
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                dispatch('getInfo');
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 更新信息
     */
    updateInfo: function updateInfo(_a, _b) {
      var dispatch = _a.dispatch;
      var name = _b.name,
          idNumber = _b.idNumber,
          bankCard = _b.bankCard;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/coin/tax_info', {
                name: name,
                id_number: idNumber,
                bank_card: bankCard
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                dispatch('getInfo');
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 赠送
     */
    give: function give(context, _a) {
      var isFreeze = _a.isFreeze,
          count = _a.count,
          userId = _a.userId,
          remark = _a.remark;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/coin/give', {
                is_freeze: isFreeze,
                count: count,
                user_id: userId,
                remark: remark
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {//
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取积分
     */
    getIntegral: function getIntegral(_a) {
      var dispatch = _a.dispatch;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/integral')];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取积分数据
     */
    getIntegralList: function getIntegralList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var last_id = _b.last_id,
          count = _b.count,
          type = _b.type,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.integral[type];

              if (!last_id && forceUpdate) {
                commit('initIntegral', {
                  type: type
                });
                wrap = state.integral[type];
              }

              if (wrap.loaded || wrap.requesting) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/integral/detail', {
                params: {
                  type: type === 'all' ? undefined : type,
                  last_id: last_id,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data; // const data = [];
              // for (let i = 0; i < 10; i++) {
              //     data.push({
              //         id: i,
              //         title: 'xxx',
              //         type: i%2 ? 'expend' : 'income',
              //         count: ((i % 2) ? '+' : '-') + '10xxx',
              //         balance: '',
              //     });
              // }
              // const rdata = {
              //     status: 0,
              //     data,
              // };

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatIntegral', {
                  type: type,
                  list: list
                });

                if (list.length < count) {
                  commit('setIntegralLoaded', {
                    type: type,
                    loaded: true
                  });
                }
              }

              commit('setIntegralReq', {
                type: type,
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;